import React from 'react';
import { Box, Checkbox, Typography, Link } from '@mui/material';

export const termsCheckboxTextSx = {
  fontFamily: 'Montserrat, sans-serif',
  fontSize: "var(--type-small)",
  fontWeight: 600,
  lineHeight: 'normal',
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
  minWidth: 0,
  flex: 1,
};

export const termsCheckboxRowSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '9px',
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
};

export const buildSmsConsentUrl = (origin: string = window.location.origin): string =>
  `${origin.replace(/\/$/, '')}/sms-consent`;

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  smsChecked?: boolean;
  onSmsChange?: (checked: boolean) => void;
  disabled?: boolean;
  color?: string;
  linkColor?: string;
  disabledColor?: string;
}
const TermsCheckbox: React.FC<TermsCheckboxProps> = ({
  checked,
  onChange,
  smsChecked = false,
  onSmsChange = () => undefined,
  disabled = false,
  color = 'white',
  linkColor = 'white',
  disabledColor = 'rgba(255, 255, 255, 0.5)'
}) => {
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    // Match latest Figma spacing
    paddingLeft: 0 // Remove any default padding
  }}>
    <Box sx={termsCheckboxRowSx}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '2px', flexShrink: 0 }}>
        <Checkbox checked={checked} onChange={e => onChange(e.target.checked)} disabled={disabled} sx={{
      color,
      width: '20px',
      height: '20px',
      padding: 0,
      marginLeft: 0,
      flexShrink: 0,
      '&.Mui-checked': {
        color
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px'
      },
      '&.Mui-disabled': {
        color: disabledColor
      }
    }} />
        <Typography aria-hidden="true" sx={{ color: '#F15112', fontSize: '16px', lineHeight: '20px' }}>*</Typography>
      </Box>
      <Typography sx={{
      ...termsCheckboxTextSx,
      color,
    }}>
        I agree to the{' '}
        <Link href="https://app.termly.io/policy-viewer/policy.html?policyUUID=957fabbb-9a04-42b5-b4d4-0d6654d58a26" target="_blank" rel="noopener noreferrer" sx={{
        fontFamily: 'Montserrat, sans-serif',
        fontSize: "var(--type-small)",
        fontWeight: 'bold',
        color: linkColor,
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
          color: linkColor,
          opacity: 0.9
        }
      }}>
          Terms of Service
        </Link>
        {' and '}
        <Link href="https://app.termly.io/policy-viewer/policy.html?policyUUID=d6abc1df-8fb8-4b87-a394-26c92f1c2f4a" target="_blank" rel="noopener noreferrer" sx={{
        fontFamily: 'Montserrat, sans-serif',
        fontSize: "var(--type-small)",
        fontWeight: 'bold',
        color: linkColor,
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
          color: linkColor,
          opacity: 0.9
        }
        }}>
          Privacy Policy
        </Link>
        {'.'}
      </Typography>
    </Box>

    <Box sx={termsCheckboxRowSx}>
      <Checkbox checked={smsChecked} onChange={e => onSmsChange(e.target.checked)} disabled={disabled} sx={{
      color,
      width: '20px',
      height: '20px',
      padding: 0,
      marginLeft: 0,
      flexShrink: 0,
      '&.Mui-checked': {
        color
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px'
      },
      '&.Mui-disabled': {
        color: disabledColor
      }
    }} />
      <Typography sx={{
      ...termsCheckboxTextSx,
      color,
    }}>
        I consent to receive SMS notifications from AllRoomie, including appointment confirmations and reminders, and account alerts. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out.{' '}
        <Link href={buildSmsConsentUrl()} target="_blank" rel="noopener noreferrer" sx={{
        fontFamily: 'Montserrat, sans-serif',
        fontSize: "var(--type-small)",
        fontWeight: 'bold',
        color: linkColor,
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
          color: linkColor,
          opacity: 0.9
        }
        }}>
          Learn more
        </Link>
        {'.'}
      </Typography>
    </Box>
    </Box>;
};
export default TermsCheckbox;
